<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row" v-if="userData.permissions['sell_medicine']==1">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(product)="data">
                  {{ data.item.product }}
                </template>
                <template #cell(unit)="data">
                  {{ data.item.unit }}
                </template>
                <template #cell(amountpaid)="data">
                  {{ data.item.amountpaid }}
                </template>
                <template #cell(quantity)="data">
                  {{ data.item.quantity }}
                  <!-- {{ Math.round(data.item.product.quantity/data.item.base_quantity) }} -->
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>     
      <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Stock Levels</span></center>
          </div>
        </div>
      </div>
      </div>
    </Layout>
  </template>
  
  <script>
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { unitsMethods, unitsComputed, selldetailsMethods, selldetailsComputed,  } from "@/state/helpers";
  
  export default {
    page: {
      title: "Stock Levels",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Medicine Sales Details",
        items: [ {text: "Dashboard",to: "/",}, {text: "Medicine Sales Details",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'product', label: 'Product', visible: true },
            { key: 'unit', label: 'Unit', visible: true },
            { key: 'quantity', label: 'Quantity', visible: true },
            {key: 'amountpaid',label:'Amount paid', visible: true},
            { key: 'addedby', label: 'Sold by', visible: true},
            { key: 'addedon', label: 'Added on', visible: false },
          ],
        id:'',
        name:'',
      };
    },
    computed: {
      ...unitsComputed,
      ...selldetailsComputed,
      List() { return this.sellproductdetails.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.sellproductdetails.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.sellproductdetails.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchUnits();
      // this.fetchStocklevels();
      this.fetchSellProductDetails();
      this.TotalRows = this.sellproductdetails.length;
      this.isBusy=false;
    },
    methods: {
      ...unitsMethods,
      ...selldetailsMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
    },
  };
  </script>